import { createFeatureSelector, createSelector } from '@ngrx/store'
import { IMapColorGeneratorState} from './map-color-generator.reducer'
import { StoreKeysEnum } from '../../../../../store/store-keys'

export const selectMapColorGeneratorFeature = createFeatureSelector<Readonly<IMapColorGeneratorState>>(StoreKeysEnum.MapColorGenerator)

export const selectMapColorGeneratorColorMap = createSelector(
    selectMapColorGeneratorFeature,
    feature => (feature.colorMap)
)

export const selectMapColorGeneratorColorMapByKey = (key: string): any => createSelector(
    selectMapColorGeneratorColorMap,
    colorMap => colorMap[key]
)

// export const selectMapColorGeneratorOffset = createSelector(
//     selectMapColorGeneratorFeature,
//     feature => (feature.offset)
// )